<template lang="pug">
    div
        email-item(
            v-for="(item, key) in emails"
            :key="key"
            :itemIndex="key"
            :item="item"
        )
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import EmailItem from './EmailItem';

    export default {
        components: {
            EmailItem
        },
        computed: {
            ...mapGetters('businesses', ['emails'])
        },
        methods: {
            ...mapActions('businesses', ['deleteEmail']),
            ...mapActions('emails', ['setEmail'])
        }
    };
</script>
